import { IDataSeriesValue } from "@/models/responses/IDataSeriesValue";
import Site from "./Site";

export default class DataSeriesBySite {
  constructor(
    public site: Site,
    public values: IDataSeriesValue[]
  ) { }
}
